import { render, staticRenderFns } from "./assignAdviser.vue?vue&type=template&id=38dc33ac&"
import script from "./assignAdviser.vue?vue&type=script&lang=js&"
export * from "./assignAdviser.vue?vue&type=script&lang=js&"
import style0 from "./assignAdviser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports